<template>
  <div>
    <div class="top_text"><v-icon>beenhere</v-icon>소재별 리포트</div>
    <div class="topTableWrap">
      <CreativeTable
        :campaignType="campaignType"
        :viewData="viewData"
        :isExcel="isExcel"
        :tab="this.tab"></CreativeTable>
    </div>
  </div>
</template>

<script>
  import CreativeTable from './CreativeTable'

  export default {
    name: 'creative_imp',
    props: {
      campaignType: String,
      viewData: Array,
      tab: String
    },
    components: {
      CreativeTable
    },
    data () {
      return {
        isExcel: false
      }
    },
    mounted () {
      window.scroll(0, 0)
      document.body.scrollTop = 0
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// CreativeImp.vue?53f82aba